module.exports = __webpack_public_path__ + "static/step-5-b96e68deb313490afee268a02e51e919.png";